import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { vnApp_leadpilot } from "../vnApp_leadpilot";
import { infoButton_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import { LpButton, LpIcon } from "~/design-system";
class usersEditInfoButton_template extends infoButton_template {
    getTemplateHtml() {
        return /* html */ `
            <div style="position: relative">
                <!-- ko ifnot: buttonLabel -->
                    <button
                        type="button"
                        class="open-button tooltip__trigger"
                        aria-label="Show tooltip"
                        data-bind="
                            event: { click: onClickToggle },
                            attr: {
                                'aria-expanded': isVisible() ? 'true' : 'false',
                                'data-state': isVisible() ? 'open' : 'closed'
                            }
                        "
                    >
                        ${LpIcon({ name: 'info', size: 16 })}
                    </button>
                <!-- /ko -->
                <!-- ko if: buttonLabel -->
                    <button type="button" class="open-button" data-bind="text: buttonLabel, event: { click: onClickToggle }"></button>
                <!-- /ko -->
                <div class="tooltips-adv" data-bind="visible: isVisible">
                    <h3 class="tooltips-adv-title" data-bind="text: title"></h3>
                    <div class="tooltips-adv-content" data-bind="html: visibleContent"></div>
                    <button type="button" class="close-button icon i-x-after" data-bind="event: { click: onClickClose }"></button>
                </div>
            </div>
        `;
    }
    getTemplateName() {
        return "usersEdit-infoButton-template";
    }
}
export class usersEdit_template extends vnTemplate {
    /**
     * @inheritDoc
     */
    getTemplateHtml() {
        return `
            <div class="w-form w-form-large users-edit-modal">
                <div class="users-edit-modal__header form-header">
                    <input id="user-id" data-bind="value: idUser" type="hidden">
                    <div class="users-edit-modal__intro">
                        <!-- ko ifnot: $data.idUser() -->
                        <h3 class="users-edit-modal__title">Add User</h3>
                        <!-- /ko -->
                        <!-- ko if: $data.idUser() -->
                        <h3 class="users-edit-modal__title">Edit User</h3>
                        <!-- /ko -->
                        <p class="users-edit-modal__subtitle profile-page__description">Manage account information and permissions</p>
                    </div>
                    ${LpButton({
            ariaLabel: 'Close',
            className: 'users-edit-modal__close',
            prefixIcon: 'x',
            shape: 'square',
            size: 'sm',
            variant: 'ghost',
            attributes: {
                'data-bind': 'event: { click: onClickCancel }',
            },
        })}
                </div>

                <div class="w-form-body users-edit-modal__body">
                    <div class="profile-page users-edit-profile">
                        <section class="profile-card">
                            <header class="profile-card__header">
                                <h2 class="profile-card__title">Profile Picture</h2>
                            </header>
                            <div class="profile-card__body">
                                <div id="dropzone" class="users-edit-upload">
                                    <div id="my-drop-zone" class="dropzone users-edit-dropzone needsclick dz-clickable">
                                        <input id="profile-pic" data-bind="value: pictureUrl" type="hidden">
                                        <div class="users-edit-dropzone__inner">
                                            <div class="users-edit-dropzone__avatar">
                                                <!-- ko if: pictureUrl() -->
                                                <img
                                                    class="users-edit-dropzone__preview"
                                                    alt=""
                                                    data-bind="attr: { src: picturePreviewUrl, alt: fullName }"
                                                >
                                                <!-- /ko -->
                                                <!-- ko ifnot: pictureUrl() -->
                                                <span class="users-edit-dropzone__placeholder icon i-user" aria-hidden="true"></span>
                                                <!-- /ko -->
                                                <span class="users-edit-dropzone__camera" aria-hidden="true">
                                                    ${LpIcon({ name: 'camera', size: 14 })}
                                                </span>
                                            </div>
                                            <div class="users-edit-dropzone__copy">
                                                <p class="users-edit-dropzone__title">
                                                    Drop your photo here or <span class="users-edit-dropzone__link">Select a file</span>
                                                </p>
                                                <p class="users-edit-dropzone__hint">Supports: JPG, PNG.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <div class="profile-columns">
                            <section class="profile-card profile-card--column">
                                <header class="profile-card__header">
                                    <h2 class="profile-card__title">Personal Information &amp; Roles</h2>
                                </header>
                                <div class="profile-card__body profile-stack">
                            


                                    <div class="profile-field-grid">
                                        ${this.renderProfileField({ id: 'firstName', label: 'First Name', binding: 'firstName' })}
                                        ${this.renderProfileField({ id: 'lastName', label: 'Last Name', binding: 'lastName' })}
                                    </div>

                                    <div class="profile-field-grid">
                                        ${this.renderProfileField({ id: 'loginName', label: 'User Name', binding: 'loginName' })}
                                        ${this.renderProfileField({ id: 'email', label: 'Email', binding: 'email', type: 'email' })}
                                    </div>


                                    <div class="profile-field">
                                        <span class="profile-field__label">Role(s)</span>
                                        <div class="users-edit-check-list users-edit-roles" data-bind="foreach: roles">
                                            <div class="w-input users-edit-check">
                                                <input
                                                    type="checkbox"
                                                    data-bind="value: id, checked: $parent.selectedRoles, attr: { id: 'role_' + id }, disable: $parent.isRoleDisabled(id)"
                                                />
                                                <label data-bind="text: name, attr: { for: 'role_' + id }"></label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="profile-field" data-bind="visible: !hasAdminRole()">
                                        <span class="profile-field__label">Properties</span>
                                        <div class="users-edit-check-list users-edit-properties" data-bind="foreach: properties">
                                            <div class="w-input users-edit-check">
                                                <input
                                                    type="checkbox"
                                                    data-bind="value: id, checked: $parent.selectedProperties, attr: { id: 'property_' + id }, disable: $parent.isPropertyDisabled(id)"
                                                />
                                                <label data-bind="text: name, attr: { for: 'property_' + id }"></label>
                                            </div>
                                        </div>
                                     
                                    </div>

                                    <p class="form-text form-text--info" data-bind="visible: hasAdminRole()">
                                        <span class="form-text__icon" aria-hidden="true">
                                            ${LpIcon({ name: 'info', size: 16 })}
                                        </span>
                                        Administrator is granted access to all of the Projects.
                                    </p>
                                </div>
                            </section>

                            <section class="profile-card profile-card--column">
                                <div class="profile-card__body profile-stack">
                                    <div class="form-group-password is-open" id="form-group-password">
                                        ${this.renderProfileField({ id: 'password', label: 'Password', binding: 'password', type: 'password', inputClass: 'input-pass' })}
                                        ${this.renderProfileField({ id: 'passwordConfirmation', label: 'Password Confirmation', binding: 'passwordConfirmation', type: 'password', inputClass: 'input-pass' })}
                                        ${this.renderProfileField({
            id: 'oldPassword',
            label: 'Password of Logged User',
            binding: 'oldPassword',
            type: 'password',
            inputClass: 'input-pass',
            tooltipHtml: this.getTooltipHtml("oldPasswordTooltip"),
        })}
                                    </div>

                                    <div class="profile-field">
                                        <label for="2FA-select" class="profile-field__label">
                                            Two-Factor Authentication
                                            ${this.getTooltipHtml("twoFactorAuthenticationTooltip")}
                                        </label>
                                        <select id="2FA-select" name="2FA" class="form-control" data-bind="value: twoFactorMethod">
                                            <option value="disabled" data-bind="attr: { disabled: !hasUpdateAccessToRolesAdmin() }">Disabled</option>
                                            <option value="email">Enabled via Email</option>
                                        </select>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>

                <div class="form-footer users-edit-modal__footer">
                    ${LpButton({
            label: 'Cancel',
            variant: 'secondary',
            attributes: {
                'data-bind': 'event: { click: onClickCancel }',
            },
        })}
                    ${LpButton({
            label: 'Save',
            variant: 'primary',
            attributes: {
                'data-bind': 'event: { click: onClickSave }',
            },
        })}
                </div>
            </div>
            `;
    }
    renderProfileField({ id, label, binding, type = 'text', inputClass = 'input-text', tooltipHtml = '', }) {
        return `
            <div class="profile-field">
                <label for="${id}" class="profile-field__label">${label}${tooltipHtml}</label>
                <input id="${id}" data-bind="value: ${binding}" type="${type}" class="${inputClass}">
            </div>
        `;
    }
    /**
     * @inheritDoc
     */
    initPartial() {
        this.twoFactorAuthenticationTooltipContent = `
        <p style="font-size: 12px; white-space: normal">
        If 2FA is enabled, the additional configured authentication method will be prompted if the user’s device, browser, user agent, location, or connection are different from their previous login attempts in the last 30 days or if a login with 2FA has not occurred in the last 30 days.
        </p>
        `;
        this.twoFactorAuthenticationTooltip = new usersEditInfoButton_template("twoFactorAuthenticationTooltip", this.getTemplateViewModel(), this.caller);
        this.twoFactorAuthenticationTooltip.setTitle("Two-Factor Authentication");
        this.twoFactorAuthenticationTooltip.setContent(this.twoFactorAuthenticationTooltipContent);
        this.oldPasswordTooltip = new usersEditInfoButton_template("oldPasswordTooltip", this.getTemplateViewModel(), this.caller);
        this.oldPasswordTooltip.setTitle("Password of Logged User");
        this.oldPasswordTooltip.setContent(`<p style="font-size: 12px; white-space: normal">Enter your OLD password here, INCASE you are changing to a new password</p>`);
    }
    getTooltipHtml(key) {
        return `<span class="info tooltip" data-bind="template: { name: 'usersEdit-infoButton-template', data: ${key} }"></span>`;
    }
    /**
     * @inheritDoc
     */
    getTemplateName() {
        return "usersEdit-form-template";
    }
    /**
     * @inheritDoc
     */
    getMainElementClasses() {
        return ["users-edit-overlay"];
    }
    /**
     * @inheritDoc
     */
    buildViewModel() {
        let huit_neuf_this = this;
        let viewModel = {
            idUser: ko.observable(''),
            firstName: ko.observable(''),
            lastName: ko.observable(''),
            loginName: ko.observable(''),
            email: ko.observable(''),
            pictureUrl: ko.observable(null),
            password: ko.observable(''),
            roles: ko.observableArray([]),
            properties: ko.observableArray([]),
            selectedRoles: ko.observableArray([]),
            selectedProperties: ko.observableArray([]),
            passwordConfirmation: ko.observable(''),
            oldPassword: ko.observable(''),
            isActive: ko.observable("1"),
            disabledRoles: ko.observableArray([]),
            disabledProperties: ko.observableArray([]),
            disableActive: ko.observable(true),
            isChangingPassword: ko.observable(false),
            hasAdminRole: ko.observable(false),
            disableSelectButtons: ko.observable(false),
            locker: true,
            twoFactorMethod: ko.observable('email'),
            hasUpdateAccessToRolesAdmin: ko.observable(false),
            isRoleDisabled: function (data) { return ko.computed(function () { return huit_neuf_this.isRoleDisabled(data); }, this); },
            isPropertyDisabled: function (data) { return ko.computed(function () { return huit_neuf_this.isPropertyDisabled(data); }, this); },
            onClickSave: function (data, event) { huit_neuf_this.onClickSave(); },
            onClickCancel: function (data, event) { huit_neuf_this.onClickCancel(); },
            onSelectAllAction: function () { huit_neuf_this.onSelectAllAction(this.properties(), this.disabledProperties()); },
            onDeselectAllAction: function () { huit_neuf_this.onDeselectAllAction(this.properties()); },
        };
        viewModel.fullName = ko.pureComputed(function () {
            const firstName = viewModel.firstName();
            const lastName = viewModel.lastName();
            return [firstName, lastName].filter(Boolean).join(" ");
        });
        viewModel.fullNameDisplay = ko.pureComputed(function () {
            return viewModel.fullName() || "New user";
        });
        viewModel.picturePreviewUrl = ko.pureComputed(function () {
            const pictureUrl = viewModel.pictureUrl();
            return pictureUrl ? `/usersImages/${pictureUrl}` : "/assets/images/default-user.png";
        });
        viewModel.isActiveChecked = ko.pureComputed({
            read: function () {
                return viewModel.isActive() === "1" || viewModel.isActive() === 1;
            },
            write: function (checked) {
                viewModel.isActive(checked ? "1" : "0");
            },
        });
        viewModel.selectedRoles.subscribe(function (checked) {
            huit_neuf_this.validateProperties();
        }, viewModel);
        return viewModel;
    }
    /**
     * Validates properties.
     */
    validateProperties() {
        this.getTemplateViewModel().hasAdminRole(this.isAdminRoleSelected());
        if (this.getTemplateViewModel().hasAdminRole()) {
            this.setSelectedProperties([]);
        }
    }
    isAdminRoleSelected() {
        const selectedRoleIds = this.getTemplateViewModel().selectedRoles();
        const roles = this.getTemplateViewModel().roles();
        for (const roleId of selectedRoleIds) {
            const role = roles.find((entry) => entry.id == roleId);
            if (role && this.isAdminRoleName(role.name)) {
                return true;
            }
        }
        return false;
    }
    isAdminRoleName(name) {
        const normalized = String(name || "").trim().toLowerCase();
        return normalized === "admin" || normalized === "administrator";
    }
    /**
     * Handles deselecting all the properties.
     *
     * @param allProperties
     */
    onDeselectAllAction(allProperties) {
        this.getTemplateViewModel().selectedProperties([]);
    }
    /**
     * Handles selecting all properties.
     *
     * @param allProperties
     * @param disabledProperties
     */
    onSelectAllAction(allProperties, disabledProperties) {
        let properties = [];
        for (let b of allProperties) {
            if (disabledProperties.indexOf(b.id) < 0) {
                properties.push(b.id);
            }
        }
        this.getTemplateViewModel().selectedProperties(properties);
    }
    /**
     * Sets selected roles.
     *
     * @param {Array<{id: number}>} selectedRoles
     */
    setSelectedRoles(selectedRoles) {
        let roles = [];
        for (let r of selectedRoles) {
            roles.push(r.id);
        }
        this.getTemplateViewModel().selectedRoles(roles);
        this.validateProperties();
    }
    /**
     * Sets selected properties.
     *
     * @param {Array<{id: number}>} selectedProperties
     */
    setSelectedProperties(selectedProperties) {
        let properties = [];
        for (let c of selectedProperties) {
            properties.push(c.id);
        }
        this.getTemplateViewModel().selectedProperties(properties);
    }
    /**
     * Handles clicking save button event.
     */
    onClickSave() {
        const vm = this.getTemplateViewModel();
        if (!vm.idUser()) {
            vm.isChangingPassword(true);
        }
        else {
            vm.isChangingPassword(!!(vm.password() || vm.passwordConfirmation() || vm.oldPassword()));
        }
        this.caller.saveEditUser();
    }
    /**
     * Determines if a role checkbox is disabled.
     *
     * @param {number} data
     * @return boolean
     */
    isRoleDisabled(data) {
        let disabled = this.getTemplateViewModel().disabledRoles();
        for (let r of disabled) {
            if (data == r || (r.hasOwnProperty('id') && data == r.id)) {
                return true;
            }
        }
        return false;
    }
    /**
     * Determines if a property checkbox is disabled.
     *
     * @param {number} data
     * @return {boolean}
     */
    isPropertyDisabled(data) {
        let disabled = this.getTemplateViewModel().disabledProperties();
        for (let c of disabled) {
            if (data == c || (c.hasOwnProperty('id') && data == c.id)) {
                return true;
            }
        }
        return false;
    }
    /**
     * Handles clicking cancel button event.
     */
    onClickCancel() {
        this.caller.cancelEditUser();
    }
    /**
     * Sets up the form.
     *
     * @param vnApp
     * @param {Object[]} allRoles
     * @param {Object[]} allProperties
     * @param {Object[]} userRoles
     * @param {Object[]} userProperties
     */
    setupForm(vnApp, allRoles = [], allProperties = [], userRoles = [], userProperties = []) {
        let hasUpdateAccessToRoles = this.caller.hasAccessToSection(vnApp_leadpilot.SECTION_ID_USER_EDIT_ROLES, vnApp_leadpilot.ACCESS_TYPE_UPDATE);
        let hasUpdateAccessToRolesAdmin = this.caller.hasAccessToSection(vnApp_leadpilot.SECTION_ID_USER_EDIT_ROLES_ADMIN, vnApp_leadpilot.ACCESS_TYPE_UPDATE);
        let hasUpdateAccessToBrands = this.caller.hasAccessToSection(vnApp_leadpilot.SECTION_ID_USER_EDIT_BRANDS, vnApp_leadpilot.ACCESS_TYPE_UPDATE);
        let canEditUserActive = this.caller.hasAccessToSection(vnApp_leadpilot.SECTION_ID_USER_EDIT_ACTIVE, vnApp_leadpilot.ACCESS_TYPE_UPDATE);
        let canUpdateAllProperies = this.caller.hasAccessToSection(vnApp_leadpilot.SECTION_ID_BRANDS_ALL, vnApp_leadpilot.ACCESS_TYPE_UPDATE);
        let disabledRoles = [];
        let disabledProperties = [];
        if (hasUpdateAccessToRoles && !hasUpdateAccessToRolesAdmin) {
            for (let x in allRoles) {
                if (allRoles[x].hasOwnProperty('name') && ('admin' === allRoles[x]['name'] || 'administrator' === allRoles[x]['name'])) {
                    disabledRoles.push(allRoles[x]);
                }
            }
        }
        else if (!hasUpdateAccessToRoles) {
            disabledRoles = allRoles;
            for (let userRole of userRoles) {
                if (userRole["id"] == 5) {
                    disabledRoles = allRoles.filter(item => item['id'] != 6);
                    break;
                }
            }
        }
        if (!hasUpdateAccessToBrands) {
            disabledProperties = allProperties;
            this.getTemplateViewModel().disableSelectButtons(true);
        }
        else if (!canUpdateAllProperies) {
            let idUserProperties = [];
            for (let userProperty of userProperties) {
                idUserProperties.push(userProperty["id"]);
            }
            disabledProperties = allProperties.filter(item => idUserProperties.indexOf(item['id']) == -1);
        }
        this.getTemplateViewModel().disabledRoles(disabledRoles);
        this.getTemplateViewModel().disabledProperties(disabledProperties);
        this.getTemplateViewModel().roles(allRoles);
        this.getTemplateViewModel().properties(allProperties);
        this.getTemplateViewModel().disableActive(!canEditUserActive);
        this.getTemplateViewModel().hasUpdateAccessToRolesAdmin(hasUpdateAccessToRolesAdmin);
    }
}
